export default __webpack_public_path__ + "static/media/live.f8e82e49.svg";